export default "__VITE_ASSET__BYD3pjyC__"